module.exports = __webpack_public_path__ + "static/media/nbc.a354cc67.png";